import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconReload = (props) => {
  props = Object.assign({viewBox: '0 0 24 24'}, props);
  return (
    <SvgIcon {...props}>
      <path d="M6,7.2c-3.3,3.3-3.3,8.7,0,12s8.7,3.3,12,0c1.1-1.1,1.9-2.6,2.3-4.2c0.3-1.5,0.2-3.1-0.3-4.6l-1.3,0.5
	c0.9,2.6,0.2,5.4-1.7,7.3c-2.8,2.8-7.3,2.8-10,0S4.2,11,7,8.2c1.6-1.6,4-2.4,6.3-2l0,3.5L17,6l-3.7-3.7l0,2.6c-1-0.2-2-0.1-3.1,0.1
	C8.6,5.3,7.1,6.1,6,7.2z"/>
    </SvgIcon>
  );
};

IconReload.displayName = 'IconReload';
IconReload.muiName = 'SvgIcon';

export default IconReload;



// WEBPACK FOOTER //
// ./src/components/Icons/IconReload.js